import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/arrow-left.svg'
import _imports_1 from '@/assets/arrow-right.svg'
import _imports_2 from '@/assets/arrow-right-gray.svg'
import _imports_3 from '@/assets/salesforce.svg'
import _imports_4 from '@/assets/redesign-image-upload.svg'
import _imports_5 from '@/assets/redesign-map.svg'


const _hoisted_1 = { class: "flex items-center gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap"
}
const _hoisted_3 = {
  key: 0,
  src: _imports_1,
  alt: "Arrow"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_2,
  alt: "Arrow"
}
const _hoisted_5 = {
  key: 1,
  class: "flex items-center gap-2 text-sm font-medium tracking-[0.01rem] text-[#898790]"
}
const _hoisted_6 = {
  key: 2,
  class: "flex items-center gap-2 text-sm font-medium tracking-[0.01rem] text-[#898790]"
}
const _hoisted_7 = {
  key: 3,
  class: "flex items-center gap-2 text-sm font-medium tracking-[0.01rem] text-[#898790]"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "text-primary-text-color font-medium text-sm tracking-[0.01rem]" }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { class: "text-primary-text-color font-medium text-sm tracking-[0.01rem]" }
const _hoisted_12 = {
  key: 6,
  class: "flex items-center gap-2 text-sm font-medium tracking-[0.01rem] text-[#898790]"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "text-primary-text-color ml-2 cursor-default"
}
const _hoisted_15 = {
  key: 7,
  class: "flex items-center gap-2 text-sm font-medium tracking-[0.01rem] text-[#898790]"
}
const _hoisted_16 = { class: "flex items-center gap-4" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "flex items-center gap-4"
}

import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import PageHeader from "../PageHeader/PageHeader.vue";
import { Project } from "@/types";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  projectDetails?: Project | null;
  phaseDetails?: any | null;
  appointmentProject?: any | null;
  appointmentDetails?: any | null;
  exampleArchive?: any | null;
  salesforceLink?: string | null;
  hasBaumappe?: boolean;
  isBaumappeOpen?: boolean;
  isInstallers?: boolean;
  isMonthlyBonus?: boolean;
  isInstallerProfile?: boolean;
  selectedWorkerProfile?: any;
  isInstallerReport?: boolean;
  bonusReports?: Array<any>;
};

type Emits = {
  (event: "toggleIsAddImageModalOpen", isOpen: boolean): void;
  (event: "toggleBaumappe", isOpen: boolean): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SecondaryPageHeader',
  props: {
    projectDetails: {},
    phaseDetails: {},
    appointmentProject: {},
    appointmentDetails: {},
    exampleArchive: {},
    salesforceLink: {},
    hasBaumappe: { type: Boolean },
    isBaumappeOpen: { type: Boolean },
    isInstallers: { type: Boolean },
    isMonthlyBonus: { type: Boolean },
    isInstallerProfile: { type: Boolean },
    selectedWorkerProfile: {},
    isInstallerReport: { type: Boolean },
    bonusReports: {}
  },
  emits: ["toggleIsAddImageModalOpen", "toggleBaumappe"],
  setup(__props: any) {

const props = __props;


const route = useRoute();
const router = useRouter();
const { t } = useTranslate();
const path = route.path;

const goBack = () => {
  router.go(-1);
};

const goForward = () => {
  router.go(+1);
};

const selectedReportMonthFromURL = computed(() => {
  return props.bonusReports?.find((item: any) => {
    return item.id === Number(route.params.reportId);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(PageHeader, null, {
    "header-left": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(route).path !== '/')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: goBack,
                class: "w-6 h-6 flex items-center justify-center cursor-pointer rounded-sm hover:bg-gray-200 duration-200"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)
              ]))]),
              _createElementVNode("button", {
                onClick: goForward,
                class: "w-6 h-6 flex items-center justify-center cursor-pointer rounded-sm hover:bg-gray-200 duration-300"
              }, [
                (
                !_unref(path).includes('projects') &&
                !_unref(path).includes('build') &&
                !_unref(path).includes('monthly-bonus')
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : (_openBlock(), _createElementBlock("img", _hoisted_4))
              ])
            ]))
          : _createCommentVNode("", true),
        (props.projectDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_RouterLink, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("global.all_projects")), 1)
                ]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "/", -1)),
              _createVNode(_component_RouterLink, {
                class: _normalizeClass(
              _unref(route).path.includes(String(_unref(route).params.id)) ? 'text-black' : ''
            ),
                to: `/projects/${_unref(route).params.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectDetails?.name), 1)
                ]),
                _: 1
              }, 8, ["class", "to"])
            ]))
          : (props.phaseDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_RouterLink, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" All Projects ", -1)
                  ]))]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "/", -1)),
                _createVNode(_component_RouterLink, {
                  to: `/projects/${_unref(route).params.id}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.phaseDetails?.project.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "/", -1)),
                _createVNode(_component_RouterLink, {
                  to: `/projects/${__props.phaseDetails?.project.name}/phase/${__props.phaseDetails.phaseId}`,
                  class: _normalizeClass(
              _unref(route).path.includes(String(_unref(route).params.phaseId))
                ? 'text-black'
                : ''
            )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.phaseDetails?.phases.find(
                (item) => String(item.phaseId) === _unref(route).params.phaseId
              )?.phase), 1)
                  ]),
                  _: 1
                }, 8, ["to", "class"])
              ]))
            : (props.appointmentProject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_RouterLink, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("global.all_projects")), 1)
                    ]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "/", -1)),
                  _createVNode(_component_RouterLink, {
                    to: `/projects/${__props.appointmentProject?.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.appointmentProject?.name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "/", -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("global.termins")), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "/", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(
              _unref(route).path.includes(String(_unref(route).params.terminId))
                ? 'text-black'
                : ''
            )
                  }, _toDisplayString(__props.appointmentDetails.name ? __props.appointmentDetails.name : "-"), 3)
                ]))
              : _createCommentVNode("", true),
        (__props.isMonthlyBonus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("installers.monthly_bonus")), 1)
            ]))
          : _createCommentVNode("", true),
        (props.isInstallers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("installers.all_installers")), 1)
            ]))
          : _createCommentVNode("", true),
        (props.isInstallerProfile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_RouterLink, {
                to: "/installers",
                class: "underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("installers.all_installers")), 1)
                ]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "/", -1)),
              _createVNode(_component_RouterLink, {
                to: __props.isInstallerReport ? `/installers/${_unref(route).params.id}` : '',
                class: _normalizeClass(
              __props.isInstallerReport
                ? 'underline cursor-pointer text-[#898790]'
                : 'no-underline cursor-default text-primary-text-color'
            )
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.selectedWorkerProfile?.fullname), 1)
                ]),
                _: 1
              }, 8, ["to", "class"]),
              (__props.isInstallerReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "/", -1)),
                    (selectedReportMonthFromURL.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(selectedReportMonthFromURL.value.month), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (props.exampleArchive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("global.build")), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    "header-right": _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        (__props.salesforceLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: __props.salesforceLink,
              target: "_blank"
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("img", {
                class: "w-[16px] h-[16px] cursor-pointer",
                src: _imports_3,
                alt: ""
              }, null, -1)
            ]))], 8, _hoisted_17))
          : _createCommentVNode("", true),
        (__props.phaseDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleIsAddImageModalOpen', true))),
                class: "flex items-center justify-center cursor-pointer"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Image"
                }, null, -1)
              ]))]),
              (__props.hasBaumappe)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleBaumappe', !__props.isBaumappeOpen))),
                    class: _normalizeClass(["flex items-center justify-center cursor-pointer p-1 rounded-primary-radius", `${__props.isBaumappeOpen ? 'bg-white' : ''}`])
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("img", {
                      src: _imports_5,
                      alt: "Map"
                    }, null, -1)
                  ]))], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})